import { render, staticRenderFns } from "./Fiscal.vue?vue&type=template&id=5aa3436b&scoped=true"
import script from "./Fiscal.vue?vue&type=script&lang=js"
export * from "./Fiscal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3436b",
  null
  
)

export default component.exports